module.exports = __webpack_public_path__ + "img/menucn_4_6.34d3c4d1.svg";